import api from './api';
import { ApiResponse } from '@/utils/api-response.util';
import {
  PaginatedClientsResponse,
  GetClientsParams,
  ClientDetails,
  Client,
  ClientOptions,
  ClientGroup,
  CreateClientGroupDto,
  UpdateClientGroupDto,
} from '../types/client';

/**
 * Отримати пагінований список клієнтів
 */
export const getClients = async (params: GetClientsParams): Promise<PaginatedClientsResponse> => {
  const queryParams: Record<string, string> = {};

  if (params.page) queryParams.page = String(params.page);
  if (params.limit) queryParams.limit = String(params.limit);
  if (params.search) queryParams.search = params.search;
  if (params.connectionStatus) queryParams.connectionStatus = params.connectionStatus;
  if (params.groupId) queryParams.groupId = String(params.groupId);

  const query = new URLSearchParams(queryParams).toString();

  const response = await api.get<ApiResponse<Client[]>>(`/clients/search?${query}`);
  const apiResponse = response.data;

  const clients = apiResponse.data;
  const meta = apiResponse.meta;

  const totalClients = parseInt(meta.total, 10);
  const limit = parseInt(meta.limit, 10);
  const currentPage = parseInt(meta.page, 10);
  const totalPages = Math.ceil(totalClients / limit);

  return {
    clients: clients,
    pagination: {
      total: totalClients,
      pages: totalPages,
      currentPage: currentPage,
      limit: limit,
    },
  };
};

/**
 * Отримати опції (підключені клієнти, статуси, групи)
 */
export const getClientOptions = async (): Promise<ClientOptions> => {
  const response = await api.get<ApiResponse<ClientOptions>>('/clients/options');
  return response.data.data;
};

/**
 * Отримати детальну інформацію про конкретного клієнта
 */
export const getClientDetails = async (id: number): Promise<ClientDetails> => {
  const response = await api.get<ApiResponse<ClientDetails>>(`/clients/${id}`);
  return response.data.data;
};

// --- Group Management ---

/**
 * Отримати всі групи експерта
 */
export const getClientGroups = async (): Promise<ClientGroup[]> => {
  const response = await api.get<ApiResponse<ClientGroup[]>>('/clients/groups');
  return response.data.data;
};

/**
 * Створити нову групу
 */
export const createClientGroup = async (data: CreateClientGroupDto): Promise<ClientGroup> => {
  const response = await api.post<ApiResponse<ClientGroup>>('/clients/groups', data);
  return response.data.data;
};

/**
 * Оновити існуючу групу
 */
export const updateClientGroup = async (id: number, data: UpdateClientGroupDto): Promise<ClientGroup> => {
  const response = await api.patch<ApiResponse<ClientGroup>>(`/clients/groups/${id}`, data);
  return response.data.data;
};

/**
 * Видалити групу
 */
export const deleteClientGroup = async (id: number): Promise<void> => {
  await api.delete(`/clients/groups/${id}`);
};

/**
 * Масове додавання клієнтів до групи
 */
export const addClientsToGroup = async (groupId: number, clientIds: number[]): Promise<void> => {
  await api.post(`/clients/groups/${groupId}/clients`, { clientIds });
};

/**
 * Видалення клієнта з групи
 */
export const removeClientFromGroup = async (groupId: number, clientId: number): Promise<void> => {
  await api.delete(`/clients/groups/${groupId}/clients/${clientId}`);
};

/**
 * Призначення набору груп клієнту (заміна)
 */
export const setClientGroups = async (clientId: number, groupIds: number[]): Promise<void> => {
  await api.post(`/clients/groups/client/${clientId}`, { groupIds });
};
